import AuthLinkValidator from './AuthLinkValidator';

export default AuthLinkValidator;
